import _ from "lodash";
import { clientNoLoader } from "./reduxLoaderApi";
/* -------------------------------------------------------------------------- */
export const uploadAPI = (
  file,
  uploadProgress,
  is_public = true,
  is_airline_public = false
) => {
  let formData = new FormData();
  formData.append("file", file);
  formData.append("is_public", is_public);
  formData.append("is_airline_public", is_airline_public);
  let percentCompleted = 0;
  let configObj = {
    timeout: 300000,
    headers: {
      "Content-Type": "multipart/form-data",
      resource: "Enroute Admin panel",
    },
    onUploadProgress: (progressEvent) => {
      if (uploadProgress) {
        if (progressEvent.total) {
          percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
        uploadProgress(percentCompleted);
      }
    },
  };
  return clientNoLoader("post")("/v2/filesmanager")(formData)(configObj)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      let errorCode = 0;
      let result_number = null;
      if (err?.response?.status) {
        errorCode = err.response.status;
      }
      if (err?.response?.data) {
        result_number = err.response.data.result_number;
      }
      return Promise.reject({
        ecode: "Services:APIs:File:Upload:2",
        err,
        errorCode,
        result_number,
      });
    });
};
/* -------------------------------------------------------------------------- */
export const downloadFileAPI = async (
  fileId,
  isPublic = true,
  headers = {}
) => {
  let path = `${isPublic ? "/public" : ""}/${fileId}`;
  try {
    const res = await clientNoLoader("get")(`/v2/filesmanager${path}`)({
      responseType: "blob",
      headers: {
        //design: "Enroute Admin panel",
        ...headers,
      },
    })({});
    // console.log({ downloadFileAPI: res });
    return res;
  } catch (err) {
    console.log(1, "catcher", err);
    let errorCode = 0;
    let result_number = null;
    if (err?.response?.status) {
      errorCode = err.response.status;
    }
    if (err?.response?.data) {
      result_number = err.response.data.result_number;
    }
    let errorResponse = {
      ecode: "Services:APIs:File:Upload:2",
      err,
      errorCode,
      result_number,
    };
    throw errorResponse;
  }
};
/* -------------------------------------------------------------------------- */

//   for (let i = 0; i < files.length; i++) {
//     formData.append("files", files[i]);
//   }
//   formData.append("is_public", is_public);

//   let percentCompleted = 0;
//   let configObj = {
//     timeout: 300000,
//     headers: {
//       "Content-Type": "multipart/form-data",
//       resource: "Enroute Admin panel",
//     },
//     onUploadProgress: (progressEvent) => {
//       if (uploadProgress) {
//         if (progressEvent.total) {
//           percentCompleted = Math.round(
//             (progressEvent.loaded * 100) / progressEvent.total
//           );
//         }
//         console.warn({ percentCompleted });
//         uploadProgress(percentCompleted);
//       }
//     },
//   };
//   try {
//     const res = await loaderClient("post")("filemanager/upload-multiple")(
//       formData
//     )(configObj);
//     return res;
//   } catch (err) {
//     let errorCode = 0;
//     let result_number = null;
//     if (err?.response?.status) {
//       errorCode = err.response.status;
//     }
//     if (err?.response?.data) {
//       result_number = err.response.data.result_number;
//     }

//     return await Promise.reject({
//       ecode: "Services:APIs:File:Upload:2",
//       err,
//       errorCode,
//       result_number,
//     });
//   }
// };
export const uploadMultipleAPI = (
  files,
  uploadProgress,
  is_public,
  is_airline_public = false
) => {
  return new Promise(async (resolve, reject) => {
    let formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    formData.append("is_public", is_public);
    formData.append("is_airline_public", is_airline_public);

    let percentCompleted = 0;
    let configObj = {
      timeout: 300000,
      headers: {
        "Content-Type": "multipart/form-data",
        resource: "Enroute Admin panel",
      },
      onUploadProgress: (progressEvent) => {
        if (uploadProgress) {
          if (progressEvent.total) {
            percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          }
          uploadProgress(percentCompleted);
        }
      },
    };

    try {
      const res = await clientNoLoader("post")("filemanager/upload-multiple")(
        formData
      )(configObj);
      resolve(res);
    } catch (err) {
      let errorCode = 0;
      let result_number = null;
      if (err?.response?.status) {
        errorCode = err.response.status;
      }
      if (err?.response?.data) {
        result_number = err.response.data.result_number;
      }

      reject({
        ecode: "Services:APIs:File:Upload:2",
        err,
        errorCode,
        result_number,
      });
    }
  });
};
